import React from 'react';

const TermCondition1 = () => {
  const htmlContent = `
  <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        <strong>마케팅 광고 활용 동의</strong>
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        &nbsp;
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        주식회사 센트리얼에서 제공하는 이벤트 및 서비스(제휴서비스 포함) 안내 등 광고성 정보를 받으시려면 마케팅 목적
        이용에 동의하여 주시기 바랍니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        신규서비스(제품) 개발 및 특화, 맞춤형 서비스 제공, 기능 개선, 인구통계학적 특성에 따른 서비스 제공 및 광고게재,
        접속 빈도파악, 이용자의 서비스 이용에 대한 통계 시 광고성 정보로 사용됩니다.
      </p>
      <ul style="list-style-type: undefined margin-left: 28px;">
        <li>이용 목적: 맞춤형 서비스 제공에 따른 마케팅&middot;광고 활용</li>
        <li>활용 항목: 휴대폰 번호</li>
        <li>제공 기간: 마케팅&middot;광고 철회 및 탈퇴 시까지</li>
      </ul>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        ※ 위의 개인정보 수집&middot;이용에 대한 동의를 거부할 권리가 있습니다.
      </p>
      <p style='margin-top:0in;margin-right:0in;margin-bottom:8.0pt;margin-left:0in;text-align:justify;font-size:13px;font-family:"Malgun Gothic",sans-serif;'>
        그러나, 동의를 거부할 경우 회원 가입 및 일부 서비스 이용이 제한됩니다.
      </p>
  `;
  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default TermCondition1;
